<template>
  <ul
    v-if="list"
    class="item-list unselectable"
  >
    <template v-if="list.length">
      <li
        v-for="item in list"
        v-show="statusFilter == -1 || item.status == statusFilter"
        :style="{ width: `${100 / column}%` }"
      >
        <div class="item-card">
          <a
            v-link="{ name: 'detail', params: { 'iid': item.iid }, query: { school: getSchool(school.abbr), type: trans(item.type), name: item.name, tag: join(item.tag, ',') } }"
            style="text-align:center;"
          >
            <div
              class="img"
              :style="{ 'backgroundImage': `url(${OSS + (item.photo === '' ? 'null' : item.photo + '!thumb')})`}"
            >
              <span v-show="item.price">${{ item.price }}</span>
            </div>
            <div class="info">
              <span>{{ item.name || '[NO NAME]' }}</span>
            </div>
          </a>
          <span class="hr"></span>
          <a
            v-link="{ name: 'u', params: { userid: item.seller ? item.seller.userid : '' } }"
            class="seller"
          >
            <div
              class="avatar"
              :style="{ backgroundImage: `url(${OSS + (item.seller ? item.seller.avatar : 'null')})` }"
            ></div>
            <div class="seller-info">
              <Row v-if="userInfo && item.seller && (item.seller.username.length <= 15)">
                <span>{{item.seller.username}}</span>
              </Row>
              <Row v-if="userInfo && item.seller && (item.seller.username.length > 15)">
                <span>{{item.seller.username.substring(0,15)}}...</span>
              </Row>
              <div class="extra-info">
                <Row v-if="item.priority>0" >
                  <span class="time">
                    {{'刚刚' }}
                  </span>
                </Row>
                <Row v-if="item.priority==0" >
                  <span class="time">
                    {{ getDateDiff(item.publish_timestamp, trans(item.type)) || '刚刚' }}
                  </span>
                </Row>
                <span class="view">&middot; 浏览 {{ item.view }}</span>
              </div>
            </div>
            <div
              v-if="item.seller && item.seller.merchant && userInfo"
              class="merchant"
            >
              <Tag
                color="blue"
                class="pc-only"
              >认证商家</Tag>
              <Tag
                color="blue"
                class="mobile-only"
              >商</Tag>
            </div>
            <div
              v-if="!(item.seller && item.seller.merchant && userInfo) && !!item.priority"
              class="merchant"
            >
              <Tag
                color="blue"
                class="pc-only"
              ><i class="icon ion-md-arrow-round-up"></i></Tag>
            </div>
          </a>
        </div>
      </li>
      <li
        v-show="statusFilter == -1 || item.status == statusFilter"
        :style="{ width: `${100 / column}%` }"
      >
        <div class="item-card">
          <slot></slot>
        </div>
      </li>
    </template>
    <div
      v-else
      style="text-align: center"
    >
      列表空
    </div>
  </ul>
  <template v-if="list == undefined">
    <loading :size="50"></loading>
  </template>
</template>

<script>
import api from '../api';
import loading from './loading';
import { DateTime } from 'luxon';
import { getSchool } from '../vuex/getters';
import { join } from 'lodash';

export default {
  components: { loading },

  vuex: {
    getters: {
      school: getSchool,
    },
  },

  props: {
    list: {
      type: Array,
      default: null,
    },
    column: {
      type: Number,
      default: 5,
    },
    userInfo: {
      type: Boolean,
      default: true,
    },
    statusFilter: {
      type: Number,
      default: -1,
    },
  },
  data () {
    return {
      OSS: api.OSS,
    };
  },

  methods: {
    join,
    trans (typeKey) {
      return this.$t(`type.${typeKey}`);
    },
    getSchool (school) {
      return `${school}校友圈`;
    },
    getDateDiff (time , type) {
      console.log('type:',type);
      if (type === 'merchant_house'){
        return '';
      }
      var minute = 1000 * 60;
      var hour = minute * 60;
      var day = hour * 24;
      var month = day * 30;
      var diffValue = DateTime.local().diff(DateTime.fromISO(time));
      if (diffValue < 0) { return; }
      var monthC = diffValue / month;
      var weekC = diffValue / (7 * day);
      var dayC = diffValue / day;
      var hourC = diffValue / hour;
      var minC = diffValue / minute;

      var result = '';
      if (this.school.id !== 1) {
        if (monthC >= 1) {
          result = '' + parseInt(monthC) + '月前';
        } else if (weekC >= 1) {
          result = '' + parseInt(weekC) + '周前';
        } else if (dayC >= 2) {
          result = '' + parseInt(dayC) + '天前';
        } else {
          result = '刚刚';
        }
      } else {
        if (monthC >= 1) {
          result = '' + parseInt(monthC) + '月前';
        } else if (weekC >= 1) {
          result = '' + parseInt(weekC) + '周前';
        } else if (dayC >= 1) {
          result = '' + parseInt(dayC) + '天前';
        } else if (hourC >= 1) {
          result = '' + parseInt(hourC) + '小时前';
        } else if (minC >= 1) {
          result = '' + parseInt(minC) + '分钟前';
        } else {
          result = '刚刚';
        }
      }

      return result;
    },
  },
};
</script>

<style scoped lang="less">
ul.item-list {
    width: 100%;
    overflow: hidden;
    li {
        display: inline-block;
        vertical-align: middle;
        overflow: hidden;
        float: left;

        width: 100%;

        padding: 0.5%;

        @media screen and (max-width: 767px) {
            width: 50% !important;
            padding: 1%;
        }
    }

    .item-card {
        background: #fff;
        border-radius: 4px;
        font-size: 14px;
        overflow: hidden;

        box-shadow: 0 1px 0px rgba(0,0,0,.15);
        transition: box-shadow 0.3s ease;
        &:hover {
            box-shadow: 0 1.5px 1px rgba(0,0,0,.15);

            .img {
                opacity: 0.7;
            }
        }

        .img {
            background-size: cover;
            background-position: center;

            width: 100%;
            height: 150px;

            position: relative;

            span {
                position: absolute;
                left: 0;
                bottom: 0;

                display: inline-block;
                padding: 4px 8px;

                border-top-right-radius: 4px;

                background: fade(#555, 70%);

                color: #fff;
            }
        }

        .hr {
            display: block;
            height: 1px;
            border-bottom: solid 1px fade(#000, 10%);

            margin: 0 5px -1px 5px;
        }

        .info, .seller {
            padding: 7px;
            text-align: left;
            color: #000;

            span {
                display: inline-block;
            }
        }

        .info {
            font-size: 1em;
            span {
                width: 100%;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
        }

        .seller {
            display: block;
            position: relative;

            font-size: 0.9em;

            & > * {
                vertical-align: middle;
            }

            & .avatar {
                width: 30px;
                height: 30px;

                background-position: center;
                background-size: cover;

                display: inline-block;

                border-radius: 100%;

                margin: 0 5px 0 0;
            }

            &:hover {
                background: rgba(0, 0, 0, 0.05);
            }

            &-info, .extra-info > * {
                display: inline-block;
                span {
                    display: block;
                }
            }

            .extra-info {
                color: #b3b3b3;
                font-size: 0.8em;
                font-weight: 600;
            }

            & .merchant {
                position: absolute;
                right: 4px;
                top: 50%;
                margin-top: -11px;
                float: right;
                & > * {
                    font-size: 0.8em !important;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// itemList.vue?466a90c7